<template>
	<div>
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<div class="list-group-accent form-group" v-if="form.parentId > 0">
							<div class="list-group-item bg-light list-group-item-accent-info">На основе платежа ID: {{ form.parentId }}</div>
						</div>

						<b-form @submit="submitForm">

						<b-alert :show="showAlertError" variant="danger">
							<ul>
								<li v-for="(error, key) in errors" :key="key">{{ error }}</li>
							</ul>
						</b-alert>
						<b-alert :show="isDeleted" variant="warning"><strong>Внимание!</strong><br>Этот платёж был удалён.</b-alert>
						<b-alert :show="showAlertSuccess" dismissible @dismissed="showAlertSuccess = false" variant="success">Данные успешно обновлены!</b-alert>

							<b-form-group horizontal label="ID">
								<div class="col-form-label"><strong>{{ paymentId }}</strong></div>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.purpose.$error }" label="Назначение" label-for="purpose" class="is-required">
								<b-form-textarea id="purpose" :rows="3" v-model.trim="form.purpose"></b-form-textarea>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.counterparty.$error }" label="Контрагент" label-for="counterparty" class="is-required">
								<b-form-textarea id="counterparty" :rows="3" v-model.trim="form.counterparty"></b-form-textarea>
							</b-form-group>

							<b-form-group horizontal id="amount" label="Сумма" label-for="amount" class="is-required w-auto">
								<b-form-input id="amount" v-model.trim="form.amount"></b-form-input>
							</b-form-group>

							<product-select v-if="loaded"
								:type="type"
								:product="this.form.productId"
								:disabled="false"
								@changeProduct="setProductId"
							></product-select>

							<b-form-group horizontal id="manager" label="менеджер" label-for="manager" class="is-required">
								<select class="form-control" v-if="users.length > 0" v-model="form.managerId" :disabled="permission.selectManager === false">
									<option value="" disabled="disabled">-- выберите менеджера --</option>
									<option v-for="(user, key) in users" :key="key" :label="user.first_name + ' ' + user.last_name" :value="user.id"></option>
								</select>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.date.$error }" label="Дата платежа" label-for="date" class="is-required">
								<date-picker id="date" @dp-change="doSetSystemDate" v-model="form.date" :config="datePickerConfig"></date-picker>
							</b-form-group>

							<b-form-group horizontal :class="{ 'has-error': $v.form.b24Id.$error }" label="Битрикс ID" label-for="bitrix24id" class="is-required w-auto">
								<b-form-input class="bitrix24id" id="bitrix24id" placeholder="ID сделки" v-model.trim="form.b24Id"></b-form-input> <b-button :href="`https://legalbis.bitrix24.ru/crm/deal/details/${form.b24Id}/`" target="_blank">Перейти в битрикс</b-button>
							</b-form-group>
							<div class="form-group separate">
								<b-form-checkbox
									id="checkbox-1"
									v-model="form.excluded"
									name="checkbox-1"
									value="1"
									unchecked-value="0"
								>
									Исключить из финансовой отчётности
								</b-form-checkbox>
							</div>
						</b-form>
					</div>
				</div>
			</div>
			<div class="card-footer">
				<div class="float-left">
					<b-button variant="primary" @click="submitForm" v-if="!isDeleted">Сохранить изменения</b-button>
				</div>
				<div class="float-right">
					<b-button variant="primary" v-if="createPaymentButton" @click="createRelativePaymentHandler" v-b-popover.hover.top="'Новый платёж будет создан на основе этого платежа и с текущей датой. Не будет учитыватсья в отчётах.'" title="Подробнее"><i class="fa fa-plus"></i> Создать платёж</b-button>
					<b-button variant="danger" @click="deletePayment" v-if="!isDeleted"><i class="fa fa-trash"></i> Удалить</b-button>
				</div>
			</div>
		</div>
		<relation-payment
			v-if="loaded"
			:show="modalCreatePaymentShow"
			:paymentId="parseInt(paymentId)"
			:productId="parseInt(form.productId)"
			@send="sendRelativePaymentHandler"
			@hide="modalCreatePaymentShow=false"
		></relation-payment>
	</div>
</template>
<script>
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import datePicker from 'vue-bootstrap-datetimepicker'
// import payment from '@/models/payment/payment'
import payment from '@/api/modules/payment/payment'
import relationPaymentAPI from '@/api/modules/payment/relation'
// import user from '@/models/user/user'
import product from '@/api/modules/product/product'
import ProductSelect from '@/components/product/ProductSelect'
import RelationPayment from '@/components/payment/update/relation'
// import { setTimeout } from 'timers';
export default {
	components: {
		datePicker,
		'product-select': ProductSelect,
		'relation-payment': RelationPayment
	},
	data () {
		return {
			loaded: false,
			// paymentId: '',
			showAlertError: false,
			showAlertSuccess: false,
			createPaymentButton: false,
			errors: [],
			type: 0,
			permission: [],
			form: {
				parentId: 0,
				amount: '',
				b24Id: '',
				date: '',
				managerId: '',
				counterparty: '',
				purpose: '',
				productId: '',
				excluded: 0
			},
			systemDate: '',
			datePickerConfig: {
				locale: 'ru',
				format: 'D MMMM, YYYY',
				useCurrent: true,
				date: ''
			},
			oldProductId: null,
			isDeleted: false,
			modalCreatePaymentShow: false
		}
	},
	props: {
		paymentId: {
			type: Number,
			required: true
		}
	},
	mixins: [
		validationMixin
	],
	validations: {
		form: {
			purpose: {
				required
			},
			counterparty: {
				required
			},
			date: {
				required
			},
			b24Id: {
				required
			}
		}
	},
	created () {
		// this.paymentId = this.$route.params.id
		this.$route.meta.title = 'Платёж ' + this.paymentId
		this.getPayment()
	},
	methods: {
		getPayment () {
			payment.getById(this.paymentId).then((result) => {
				let data = result.body.data
				this.form.parentId = data.parent_id
				this.form.productId = data.product_id
				this.form.managerId = data.manager_id !== null ? data.manager_id : ''
				this.form.date = moment(data.date).format('D MMMM, YYYY')
				this.form.b24Id = data.b24_id
				this.form.purpose = data.purpose
				this.form.counterparty = data.counterparty
				this.form.amount = data.amount// this.$options.filters.currency(data.amount)
				this.form.excluded = data.excluded
				this.permission = result.body.permission
				if (data.product_id !== null) this.createPaymentButton = true
				if (data.manager_id === null) this.form.managerId = this.$store.state.user.id
				// if (this.permission.selectManager === false) this.form.managerId = this.$store.state.user.id

				if (this.form.productId > 0) {
					this.oldProductId = this.form.productId
					this.getProduct()
				} else {
					this.loaded = true
				}

				if (data.hasOwnProperty('is_deleted') && data.is_deleted === 1) {
					this.isDeleted = true
				}
			})
		},
		getProduct () {
			product.getProductById(this.form.productId).then((result) => {
				product.getProductTypeParent(result.type_id).then((result) => {
					this.type = result[0].id
					this.loaded = true
				})
			})
		},
		doSetSystemDate (e) {
			if (e.date !== false) this.systemDate = moment(e.date).format('YYYY-MM-DD')
		},
		setProductId (id) {
			this.form.productId = id
		},
		alertCloseHandler () {
			this.showAlert = false
		},
		clearForm () {
			Object.keys(this.form).forEach((key, index) => {
				this.form[key] = ''
			})
		},
		clearErrors () {
			this.errors = []
		},
		async submitForm () {
			try {
				if (this.oldProductId !== null && this.oldProductId !== this.form.productId) {
					await this.$dialog.confirm('<strong>Внимание!</strong><br>При смене продукта будет создан новый платёж на основе этого. <strong>Старый платёж будет удалён.</strong>')
				}

				let data = {
					amount: this.form.amount,
					date: this.systemDate,
					b24_id: this.form.b24Id,
					manager_id: this.form.managerId,
					counterparty: this.form.counterparty,
					purpose: this.form.purpose,
					product_id: this.form.productId,
					excluded: parseInt(this.form.excluded)
				}
				payment.update(this.paymentId, data).then((result) => {
					// this.clearForm()
					// this.showAlertSuccess = true
					this.$router.go(-1)
					this.$notify({
						group: 'default',
						title: 'Поздравляем!',
						text: 'Данные успешно сохранены.'
					})
				}, (response) => {
					if (response.body.hasOwnProperty('errors')) {
						this.clearErrors()
						const errors = response.body.errors
						for (let key in errors) {
							this.errors.push(errors[key][0])
						}
					}
					this.showAlertError = true
				})
			} catch (err) {
				console.error(err)
			}
		},
		createRelativePaymentHandler () {
			this.modalCreatePaymentShow = true
			payment.getById(this.paymentId).then((result) => {
				console.log(result)
			})
		},
		sendRelativePaymentHandler (id) {
			this.$store.commit('TOGGLE_PROGRESS')
			const params = {
				payment_id: parseInt(this.paymentId),
				product_id: id
			}
			relationPaymentAPI.create(params).then((result) => {
				this.$router.push({path: `/payments/details/${result.id}/update`})
				setTimeout(() => {
					this.$store.commit('TOGGLE_PROGRESS')
				}, 1000)
			}, (response) => {
				alert(response.body.errors)
			})
		},
		deletePayment () {
			this.$dialog.confirm('Вы действительно хотите удалить платёж?').then(() => {
				payment.delete(this.paymentId).then((result) => {
					this.$store.commit('TOGGLE_PROGRESS')
					setTimeout(() => {
						this.$router.go(-1)
						this.$store.commit('TOGGLE_PROGRESS')
					}, 1000)
				})
			})
		}
	},
	computed: {
		users () {
			const output = []
			const users = this.$store.getters['userModule/users']
			for (let index in users) {
				if ((users[index].role === 'manager' || users[index].role === 'supermanager') && users[index].status === 1) {
					output.push(users[index])
				}
			}

			return output
		}
	},
	watch: {
		paymentId: function (val) {
			this.$route.meta.title = 'Платёж ' + this.paymentId
			this.getPayment()
		}
	}
}
</script>
<style lang="scss">
	.el-select {
		width: 100%;
	}
	.el-alert {
		margin-bottom: 15px;
	}
	.bitrix24id {
		float: left;
		margin-right: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/payment/update/default.vue